import { _ } from "~/i18n";
import { likeButton } from "~/photo/components/like-button";
import { viewCount } from "~/photo/components/view-count";
import { icon, node } from "~/util/dom";

export function createGalleryPIG(cont, imageData, scroller, conf) {
	const id = cont.id;

	if (!id) {
		cont.id = `pig-${Math.round(Math.random()*10000)}`;
	}

	if (imageData && imageData.length) {
		const options = {
			containerId: cont.id,
			spaceBetweenImages: 6,
			transitionSpeed: 200,
			primaryImageBufferHeight: 400,
			secondaryImageBufferHeight: 300,
			thumbnailSize: Mapy.CDN.SIZE_40_40,
			scroller,
			imageElementFactory: data => {
				const element = node("figure");
				const imageContainer = node("div", { title: data.name });
				const figcaption = node("figcaption", { className: `gallery-figcaption ar-${data.aspectRatio < 1 ? `0` : data.aspectRatio < 1.4 ? `1` : `2`}`, title: data.name });
				// eslint-disable-next-line new-cap
				const button = likeButton(data);
				// eslint-disable-next-line new-cap
				const viewCountCont = viewCount(data.viewCount);
				const right = node("div", { className: "right" });
				const context = icon("etc-vertical");

				figcaption.appendChild(node("span", { innerHTML: data.title }));

				element.appendChild(imageContainer);

				if (data.status === "rejected") {
					const approved = node("div", { className: "pig-rejected" });
					const text = node("span", {}, _("gallery.reviewError"));

					approved.appendChild(text);

					element.appendChild(approved);
				} else if (data.approved === false) {
					const approved = node("div", { className: "pig-not-approved" });
					const text = node("span", {}, _("gallery.notApproved"));

					approved.appendChild(icon("time"));
					approved.appendChild(text);

					element.appendChild(approved);
				}

				if (Mapy.CUS.userweb?.photoBeautyScore) {
					const beatySpan = node("span", { textContent: `beauty score: ${data.beautyScore ? data.beautyScore.toFixed(3) : "-"}` });

					beatySpan.style.overflow = "visible";
					right.append(beatySpan);
				}

				element.appendChild(figcaption);
				element.setAttribute("data-id", data.id);
				element.setAttribute("data-source", data.source);
				if (conf.viewCount) {
					right.appendChild(viewCountCont);
				} else {
					right.appendChild(button);
				}
				right.appendChild(context);
				figcaption.appendChild(right);

				return [element, imageContainer];
			},
			urlForSize: (filename, size) => {
				const small = size.width < 100 || size.height <= 500;

				return Mapy.CDN.setSize(filename, size, false, small);
			},
			getMinAspectRatio: () => {
				const width = cont.offsetWidth;
				let aRatio = 6;

				if (width <= 520 || Mapy.Util.isSmallResolution()) { // Phones
					return 2;
				} else if (width <= 800) { // Tablets
					return 3;
				}

				const boarderLine = conf.resizer.boarderLine;

				if (boarderLine && boarderLine.length) {
					boarderLine.forEach((bl, index) => {
						if (bl > 0 && width >= bl) {
							aRatio = index + 1;
						}
					});
				}

				return aRatio;
			},
			getImageSize: lastWindowWidth => {
				const width = cont.offsetWidth;

				if (lastWindowWidth >= 1920) {
					return {
						...Mapy.CDN.SIZE_667_500,
						...{ width: "" },
					}; // Large desktops
				}
				if (width <= 440 && Mapy.Util.isSmallResolution()) {
					return Mapy.CDN.SIZE_400_400;
				} else if (width <= 789 && Mapy.Util.isSmallResolution()) {
					return Mapy.CDN.SIZE_667_500;
				} else if (width <= 400) {
					return Mapy.CDN.SIZE_200_200;
				} else if (width <= 520) {
					return Mapy.CDN.SIZE_300_300;
				} else if (lastWindowWidth <= 1920) {
					return Mapy.CDN.SIZE_500_500;
				}

				return Mapy.CDN.SIZE_600_600;
			},
		};

		// @ts-ignore
		const ppig = new Pig(imageData, options);

		return ppig;
	}

	return null;
}
